import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';
import { ICONS_CODEPOINTS } from '../../../../../styles/icons';
/**
 * Grid size options list
 */
export const GridSizeOptions: NICmsContentField.IOption[] = [
    { key: 12, title: '1' },
    { key: 6, title: '2' },
    { key: 4, title: '3' },
    { key: 3, title: '4' },
    { key: 2, title: '6' },
    { key: 1, title: '12' }
];
const icons = Object.keys(ICONS_CODEPOINTS).map(iconKey => {
    return {
        key: `icon-${iconKey}`,
        title: iconKey
    };
});
export const IconsOptions: NICmsContentField.IOption[] = [...UndefinedOption, ...icons];
export const presetColors = [
    '#2E2C4E',
    '#2A2A34',
    '#2862CC',
    '#54748F',
    '#33BBC3',
    '#036464',
    '#527570',
    '#11830B',
    '#015F57',
    '#354230',
    '#8E7C70',
    '#834C17',
    '#7A2F40',
    '#9D2237',
    '#61373F',
    '#802A49',
    '#6B5768',
    '#9C848F',
    '#BDA11E',
    '#FFFFFF',
    '#8C9091',
    '#1D1D1B',
    '#5D619D',
    '#E14E80',
    '#EC6577',
    '#84948D',
    '#272D3B',
    '#998A76',
    '#646363',
    '#92CDB8',
    '#F3E778',
    '#B09D8E',
    '#9F5069',
    '#463053',
    '#8C9091',
    '#8C9092',
    '#DCDCDC',
    '#203E4A',
    '#4D3246',
    '#33B8C3',
    '#CCC38A',
    '#1A5091',
    '#000000',
    '#3144EF',
    '#745815',
    '#5E3F11',
    '#505050',
    '#5A5A5A',
    '#EAE9DE',
    '#944901',
    '#6CB3CA',
    '#EFEFDD',
    '#6A3927',
    '#473442',
    '#C89826',
    '#462639',
    '#27632D',
    '#37503D',
    '#4F497E',
    '#3A3536',
    '#1F495B',
    '#573B1B',
    '#305A28',
    '#DCD8AE',
    '#769DBD',
    '#D48E27',
    '#EC7317',
    '#124961',
    '#DF7DB7',
    '#582147',
    '#6C393F',
    '#A89470',
    '#9E6FCD',
    '#A31212',
    '#E7B2A4',
    '#EDA6A2',
    '#973A36',
    '#D4D4D4',
    '#939393',
    '#3AB0A2',
    '#A85F08',
    '#8D7045',
    '#959595',
    '#736460',
    '#E8E453'
];
